import styled from "styled-components";
import React from "react";
import {getTheme} from "../../../shared/themeUtils";

const BrandTitle = styled.div`
  display: flex;
  align-items: center;

  .img-placeholder {
    margin-right: ${getTheme("space.3")};
    height: 60px;
    width: 80px;
  }

  h1 {
    padding-left: ${getTheme("space.3")};
    margin-bottom: 0;
  }
`

const BrandHeadingPlaceholder = () => {
  return (
    <BrandTitle className="placeholder-wave">
      <div className="placeholder img-placeholder"></div>
      <h1 className="placeholder">Brand title</h1>
    </BrandTitle>
  )
}

export default BrandHeadingPlaceholder
